angular.module('unica_relator.relator_controllers')

.controller('RelatorEditController', function(
	$rootScope, $scope, $state, $stateParams,
	RelatorEditService
) {

	$scope.pageTitle = 'Modifica Relatore';

	$rootScope.getRelator( $stateParams.id );

	$scope.saveRelator = function() {
		$scope.showLoader();

		if ( typeof $rootScope.relatorData.avatar !== "undefined" ) {
			$rootScope.relatorData.avatar = $rootScope.relatorData.avatar.dataURL;
		} else {
			$rootScope.relatorData.avatar = '';
		}

		var relatorData = angular.copy($rootScope.relatorData);

		RelatorEditService
			.update(relatorData)
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {

					data.avatar = {
						dataURL: data.avatar,
						resized: {
							dataURL: data.thumb
						}
					};

					$rootScope.relatorData = data;

					$scope.showSuccessMsg('Relatore aggiornato con successo!', '');
					//$state.go('app.event.list', { year: $rootScope.year });
				} else {
					$rootScope.manageError(data);
				}
			});

	};

})

;